import React from 'react';
import {useTranslation} from 'react-i18next';
import {Image} from '@/components-v2';
import globalStore from '@services/global.state';

const GameContainer = ({
  children,
  closed,
  className,
  onClick,
  gameName,
  ...otherProps
}: {
  closed: boolean;
  gameName: string;
} & React.HTMLAttributes<HTMLDivElement>) => {
  const {t} = useTranslation();
  return (
    <div
      className={'relative ' + (closed ? '' : 'click-op ') + (className || '')}
      {...otherProps}
      onClick={e => {
        if (closed) {
          globalStore.globalTotal.next({
            type: 'warning',
            message: t('home.tip.closed', {
              name: gameName,
            }),
          });
        } else {
          onClick?.(e);
        }
      }}>
      <>
        {children}
        {closed && (
          <div className="absolute left-0 top-0 w-full h-full bg-white opacity-50 z-10">
            <Image
              src="/images/closed.webp"
              alt="closed"
              className="size-16 absolute right-2 top-2"
            />
          </div>
        )}
      </>
    </div>
  );
};

export default GameContainer;
